import React, { useState, useEffect } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';
import { useRouter } from 'next/navigation';
import { getAllProjects, getAllRequestedProjects, setActiveProject, joinProject, getActiveProject } from '@/utils/all_apis/project';
import { getUserIsClient } from '@/utils/all_apis/admin';

const ProjectsDashboard = () => {
  const router = useRouter();
  const [userProjects, setUserProjects] = useState([]);
  const [requestedProjects, setRequestedProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const [activeProject, setCurActiveProject] = useState<any>(null);
  const [userIsClient, setUserIsClient] = useState<boolean>(false)

  useEffect(() => {
    const fetchProjects = async () => {
      const memberProjs = await getAllProjects();
      setUserProjects(memberProjs);

      const requestedProjs = await getAllRequestedProjects();
      setRequestedProjects(requestedProjs);

      const activeProjectGet = await getActiveProject()
      setCurActiveProject(activeProjectGet)

      const isUserClient:any = await getUserIsClient()
      if(typeof isUserClient == 'boolean'){
        setUserIsClient(isUserClient)
      }
    };

    fetchProjects();
  }, []);

  const handleSetActiveProject = async (projectId: number) => {
    const response = await setActiveProject(projectId.toString());
    if (response) {
      window.location.reload();
    } else {
      alert('Failed to set project as active');
    }
  };

  const handleJoinProject = async (projectId: any) => {
    const response = await joinProject(projectId);
    if (response) {
      window.location.reload();
    } else {
      alert('Failed to join project');
    }
  };

  const handleCreateProject = () => {
    router.push('create-project');
  };

  const handleProjectClick = (project: any) => {
    setSelectedProject(project);
  };

  const handleCloseModal = () => {
    setSelectedProject(null);
  };

  const hasProjects = userProjects.length > 0 || requestedProjects.length > 0;

  return (
    <div className="flex flex-col w-full h-[calc(100vh-48px)] p-4">
      {userIsClient &&
      <div className="flex justify-center mb-4">
        <button
          onClick={handleCreateProject}
          className="bg-blue-500 text-white px-4 py-2 rounded flex items-center"
        >
          <FaPlus className="mr-2" /> Create Project
        </button>
      </div>}
      {hasProjects ? (
        <>
          <div className={`w-full ${requestedProjects.length > 0 ? 'md:w-1/2' : ''} p-4`}>
            <h1 className="text-xl font-bold mb-4">Your Projects</h1>
            {userProjects.length === 0 ? (
              <p className="text-gray-500">No projects available. {userIsClient && <span>Create a new project to get started.</span>}</p>
            ) : (
              <ul className="space-y-4">
                {userProjects.map((project: any) => (
                  <li key={project.id} className="bg-white p-4 rounded shadow flex items-center justify-between">
                    <div>
                      <button
                        onClick={() => handleProjectClick(project)}
                        className="text-lg font-bold text-blue-500 hover:underline"
                      >
                        {project.title}
                      </button>
                    </div>
                    {
                      activeProject && activeProject.id == project.id ?
                      <span>Current Active Project</span>:
                    
                    <button
                      onClick={() => handleSetActiveProject(project.id)}
                      className="bg-green-500 text-white px-3 py-1 rounded"
                    >
                      Set Active
                    </button>}
                  </li>
                ))}
              </ul>
            )}
          </div>
          {requestedProjects.length > 0 && (
            <div className="w-full md:w-1/2 p-4">
              <h1 className="text-xl font-bold mb-4">Projects Requested to Join</h1>
              <ul className="space-y-4">
                {requestedProjects.map((project: any) => (
                  <li key={project.id} className="bg-white p-4 rounded shadow flex items-center justify-between">
                    <div>
                      <button
                        onClick={() => handleProjectClick(project)}
                        className="text-lg font-bold text-blue-500 hover:underline"
                      >
                        {project.title} <span className="text-gray-500 text-sm">{project?.user?.email ? " by "+project?.user?.email: <></>}</span>
                      </button>
                    </div>
                    <button
                      onClick={() => handleJoinProject(project.id)}
                      className="bg-green-500 text-white px-3 py-1 rounded"
                    >
                      Join
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      ) : (
        <div className="flex flex-col items-center justify-center h-full w-full p-4">
          <p className="text-gray-500">No projects available. {userIsClient && <span>Create a new project to get started.</span>}</p>
        </div>
      )}
      {selectedProject && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
          <div className="bg-white p-8 rounded-lg relative">
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            >
              <FaTimes />
            </button>
            <h2 className="text-xl font-bold mb-4">{selectedProject.title}</h2>
            <p className="mb-2"><strong>Created By:</strong> {selectedProject?.user?.email}</p>
            <p className="mb-2"><strong>Status:</strong> {selectedProject.status}</p>
            <p className="mb-2"><strong>Created At:</strong> {new Date(selectedProject.created_at).toLocaleString()}</p>
            <p className="mb-2"><strong>Updated At:</strong> {new Date(selectedProject.updated_at).toLocaleString()}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectsDashboard;